import React from "react";
import { HomeHeader } from "@/components/home/HomeHeader";
import { HomeBookingProvider } from "@/components/home/HomeBookings";

// Same approved header, wordmark and mobile menu; existing inner-route links retained.
const links = [["home", "/"], ["carta", "/carta"], ["grupos", "/menus-para-grupos"], ["tienda", "/tienda"], ["locales", "/locales"], ["naguara", "/naguara"], ["finca", "/finca"], ["historia", "/historia"]];

export const Header = () => <HomeBookingProvider>
  <div className="ritual-editorial rh-inner-header-scope" data-testid="shared-header-system"><HomeHeader inner links={links} /></div>
</HomeBookingProvider>;